import Axios from "axios";
import { COOKIES_ACCESS_TOKEN, COOKIES_CLIENT_ID } from "./cookies";

const apiDev = Axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
});

apiDev.interceptors.request.use((config) => {
  let accessToken, clientId;
  if (typeof window !== "undefined") {
    accessToken = window.sessionStorage.getItem(COOKIES_ACCESS_TOKEN);
    clientId = window.sessionStorage.getItem(COOKIES_CLIENT_ID);
  }
  if (accessToken && clientId) {
    config.headers.Authorization = `Bearer ${accessToken}`;
    config.headers.ClientId = clientId;
  }
  return config;
});

const apiProd = Axios.create({
  baseURL: process.env.REACT_APP_PROD_API_URL,
  timeout: 10000,
});

apiProd.interceptors.request.use((config) => {
  let accessToken, clientId;
  if (typeof window !== "undefined") {
    accessToken = window.sessionStorage.getItem(COOKIES_ACCESS_TOKEN);
    clientId = window.sessionStorage.getItem(COOKIES_CLIENT_ID);
  }
  if (accessToken && clientId) {
    config.headers.Authorization = `Bearer ${accessToken}`;
    config.headers.ClientId = clientId;
  }
  return config;
});

export { apiDev, apiProd };
